const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}

export default graphConfig
